/* CMS: zdjęcia koloru z panelu Shopify (featured_image pierwszego wariantu danego koloru). Ładuje się po pdp-color-photos.js, przed pdp-wizard.js. */
(function () {
  'use strict';
  var S = window.AV_SHOP_PRODUCT;
  var root = document.querySelector('[data-product-page]');
  if (!S || !root) return;
  var model = root.dataset.model || S.handle;
  var norm = function (u) { return String(u || '').split('?')[0].split('/').pop().replace(/^pdp-(img|card)-/, '').toLowerCase(); };
  var cp = ((window.ALTIVEST_COLOR_PHOTOS || {}).products || {})[model];
  // zdjęcia koloru z pierwszego wariantu danego koloru (tylko kolory, które mają już zestaw zdjęć w katalogu)
  if (cp && cp.photos) {
    var toks = function (s) { return String(s).toLowerCase().split(' · ').map(function (t) { return t.trim(); }); };
    Object.keys(S.colorImages || {}).forEach(function (sc) {
      var st = toks(sc);
      Object.keys(cp.photos).forEach(function (ck) {
        var ct = toks(ck);
        if (ct.every(function (t) { return st.indexOf(t) >= 0; })) {
          var ph = cp.photos[ck], url = S.colorImages[sc];
          if (norm(url) !== norm(ph.front || ph.hero)) { if (ph.hero) ph.hero = url; if (ph.front) ph.front = url; }
        }
      });
    });
  }

})();
